<template>
    <el-radio-group
        :value="value"
        @input="handleInput"
        @change="handleChange"
        v-bind="$attrs"
        v-on="listeners"
    >
        <el-radio v-for="item in getData" :key="item.value" :label="item.value" :disabled="item.disabled">{{item.label}}</el-radio>
    </el-radio-group>
</template>

<script>
import enumMixin from '../mixin/enum.js';
/**
 *  @author 于新哲
 *  @since 1.3.2
 *  radiogroup
 */
export default {
    name: 'XxRadioGroup',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            data: this.list
        };
    },
    computed: {
        listeners() {
            let { change, input, ...listeners } = this.$listeners;
            return listeners;
        }
    },
    methods: {
        handleInput(v) {
            this.$emit('input', v);
        },
        handleChange(v) {
            this.$emit('change', v);
        }
    },
    mixins: [enumMixin]
};
</script>
